module.exports = __webpack_public_path__ + "img/all-events.bbbec832.jpg";